import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

const DesignEditor = ({ className, children }) => {
  const classes = classNames({
    'design-editor': true,
    [className]: !!className,
  });

  return <div className={classes}>{children}</div>;
};

DesignEditor.propTypes = propTypes;

export default DesignEditor;
